import React, { useEffect, useRef, useState } from 'react';
import * as d3 from 'd3';
import data from './goldmedalistsinfo.json';
import './dataviz.scss';
import Tooltip from './Tooltip';
import ImageScroll from './ImagesScroll';

const CareerTrend = () =>  {
    const svgRef = useRef();
    const containerRef = useRef();

    const [tooltipContent, setTooltipContent] = useState(null);
    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
    const [hovered, setHovered] = useState(null);

    const careerTypes = ['体制内', '体制外'];

    const color = d3.scaleOrdinal()
      .domain(['体制内', '体制外'])
      .range(['#ED6E79', '#658DE5']);

  
      useEffect(() => {
        drawChart();

        const handleResize = () => {
            drawChart();
        }; 
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []); 

  const drawChart = () =>  {
    // const margin = { top: 20, right: 30, bottom: 40, left: 60 };
    // const width = 960 - margin.left - margin.right;
    // const height = 300 - margin.top - margin.bottom;

    // const svg = d3.select(svgRef.current)
    //   .attr('width', width + margin.left + margin.right)
    //   .attr('height', height + margin.top + margin.bottom)
    //   .append('g')
    //   .attr('transform', `translate(${margin.left},${margin.top})`);

    const container = d3.select(containerRef.current);
    const svg = d3.select(svgRef.current);
    const containerWidth = container.node().clientWidth;
    const containerHeight = container.node().clientHeight;

  
    const margin = { top: 20, right: 10, bottom: 40, left: 40 };
    const width = containerWidth - margin.left - margin.right;
    const height = containerHeight - margin.top - margin.bottom;

    svg
      .attr('viewBox', `0 0 ${containerWidth} ${containerHeight}`)
      .attr('preserveAspectRatio', 'xMinYMid')
      .attr('width', '100%')
      .attr('height', '100%');

    const svgGroup = svg
      .selectAll('g')
      .data([null])
      .join('g')
      .attr('transform', `translate(${margin.left},${margin.top})`);

      const filteredData = data.filter(d => d.careerType !== '不详' && d.careerType !== '现役' && d.retirementYear !== '现役');

      const groupedData = d3.rollup(
          filteredData,
          v => ({
              '体制内': d3.sum(v, d => d.careerType === '体制内' ),
              '体制外': d3.sum(v, d => d.careerType === '体制外' )
          }),
          d => d.retirementYear
          );
  
      const years = d3.range(1984, 2024);
  
      const combinedData = Array.from(groupedData, ([key, value]) => ({
          year: key,
          '体制内': value['体制内'],
          '体制外': value['体制外'],
          'isPlaceholder': false
          }));
      combinedData.sort((a, b) => a.year - b.year);
  
      years.forEach(year => {
        const found = combinedData.find(item => item.year === year);
        if (!found) {
          combinedData.push({ year, '体制内': 0, '体制外': 0, isPlaceholder: year === 1999 });
        }
      });
      combinedData.sort((a, b) => a.year - b.year);
    

    const x = d3.scaleBand()
      // .domain(combinedData.map(d => d.year))
      .domain(years)
      .range([0, width])
      .paddingInner(0.17)
      .paddingOuter(0.1);

    const y = d3.scaleLinear()
      .domain([0, 1])
      .range([height, 0]);

    

    const stack = d3.stack()
      .keys(['体制内', '体制外'])
      .order(d3.stackOrderNone)
      .offset(d3.stackOffsetExpand);

    const series = stack(combinedData);

      

    //y
    svgGroup.append('g')
      .attr('class', 'grid')
      .call(d3.axisLeft(y)
        .tickValues([0.25, 0.5, 0.75])
        .tickSize(-width - 10)
        .tickFormat('')
      )
      .call(g => g.select('.domain').remove()); 
      
    svgGroup.append('g')
      .attr('class','y-axis')
      .call(d3.axisLeft(y)
      .tickValues([0.5])
      .tickFormat(d3.format(".0%")))
      .call(g => g.select(".domain").remove());

    svgGroup.append('g')
      .attr('class','mobile-tick')
      .call(d3.axisLeft(y)
      .tickValues([1])
      .tickFormat(d3.format(".0%")))
      .call(g => g.select(".domain").remove())
      .call(g => g.selectAll(".tick text")
      .attr("dy", "-0.7em")
      // .attr("x", 0) // Align the text to the left
      .style("text-anchor", "start"))
      .call(g => g.selectAll(".tick line").remove()
  );

    svgGroup.selectAll('.grid .tick line')
      .attr('class', 'grid-lines')
      .attr('transform', `translate(-5, 0)`); 

    
    //1999
    svgGroup.selectAll('rect').remove(); 

    svgGroup.append('rect')
          .attr('x', x(1999))
          .attr('y', y(1))
          .attr('width', x.bandwidth())
          .attr('height', y(0) - y(1))
          .attr('fill', '#CCCCCC')
          .attr('opacity', 0.5)
          .on('mouseover', (event, d) => {
            setTooltipContent(
              `<div class='tooltip__content'>
              <span class="tooltip__details"><b>1999</b></span>
              <span class="tooltip__title">
            <span>Outside State System: 0</span></br>
            <span>Within State System: 0</span>
          </span>
              </div>`
            )
            setTooltipPosition({ x: event.pageX + 10, y: event.pageY - 28 })
            setHovered(event.target);
          })
          .on('mouseout', () => {
            setTooltipContent(null)
            setHovered(null);
          });

    svgGroup.append('g')
      .selectAll('g')
      .data(series)
      .enter().append('g')
      .attr('fill', d => color(d.key))
      .selectAll('rect')
      .data(d => d)
      .enter().append('rect')
      .attr('x', d => x(d.data.year))
      .attr('y', d => y(d[1]))
      .attr('height', d => y(d[0]) - y(d[1]))
      .attr('width', x.bandwidth())
      .on('mouseover', (event, d) => {
        const rect = event.target.getBoundingClientRect();
        const yearData = combinedData.find(item => item.year === d.data.year);
        setTooltipContent(
          `<div class="tooltip__content">
          <span class="tooltip__details"><b>${d.data.year}</b></span>
          <span class="tooltip__title">
            <span style="color:#658DE5">Outside</span> State System: <span style="color:#658DE5"><b>${yearData['体制外']}</b> athletes</span></br>
            <span style="color:#ED6E79">Within</span> State System: <span style="color:#ED6E79"><b>${yearData['体制内']}</b> athletes</span>
          </span>
          </div>`
        );
        // setTooltipPosition({ x: event.pageX + 10, y: event.pageY - 28 })
        setTooltipPosition({ 
          x: window.scrollX + rect.x + rect.width/2, // Center of the hovered element
          y: window.scrollY + rect.y
        });
        setHovered(event.target);
      })
      .on('mouseout', () => {
        setTooltipContent(null)
        setHovered(null);
      });

    //x
    svgGroup.append('g')
      .attr('class', 'x-axis')
      .attr('transform', `translate(0,${height})`)
      .call(d3.axisBottom(x)
        .tickValues(x.domain().filter(year => year % 4 === 0))
        .tickSize(0));

  }

  const careerTypeMap = {
    "体制内": "Within State System",
    "体制外": "Outside State System",
  };
  
    return (
      <>
      <div className='content'>
        <div className='content__text'>
          <h3>1987–2000: A brief peak in employment outside the state-sponsored sport system</h3>

          <div className='legend'>
          {careerTypes.map((type, i) => (
            <div key={type} className='legend__item'>
              <div className='legend__color' style={{ backgroundColor: color(type) }}></div>
              <div className='legend__label'>{careerTypeMap[type] || type}</div>
            </div>
          )
        )}
        </div>
        </div>

      </div>
      <div ref={containerRef} className='chart-container' style={{ overflowY:'clip' }}>
        <svg ref={svgRef} id='career-trend'></svg>
        <Tooltip content={tooltipContent} position={tooltipPosition} hovered={hovered} />
      </div>

      <div className='content'>
      <div className='scroll__caption chart-caption'>Note: The horizontal axis represents the retirement years of Olympic champions. The red and blue colors indicate employment ratio of retired Olympic champions within and outside the system for each year, respectively. Hover over the chart to see the specific number of people employed within and outside the system for that year.</div>
        
        <div className='content__text'>

          <p>As seen in the chart, from 1984 to the present, the number of Olympic champions employed within the system (represented in red) has consistently been much higher than those working outside the system (represented in blue). "Within the system" employment has been the dominant choice for most Olympic champions. However, it is worth noting that between 1987 and 2000, there were several small peaks in "outside the system" employment, with business ventures being a primary career path. Some scholars view this period as a transition from a "state-assigned employment" model to a "market-driven" system.</p>
          <p>It was during this time that Olympic champions began venturing into entrepreneurship and business after retirement. One prominent example is Li Ning, known as the "first prince of gymnastics." He won six medals (three gold, two silver, and one bronze) at the 1984 Olympics. After retiring in 1988, he first joined Guangdong Jianlibao Group, and later founded the "Li Ning" brand—now one of China's most influential sportswear brands.</p>
          <p>After 2002, the central and local governments introduced policies to support the reemployment and further education of retired athletes. Since then, the proportion of Olympic champions employed outside the system has never surpassed those within it.</p>
          <p>Among China’s traditionally strong Olympic sports, gymnastics is the only discipline where employment within and outside the system is nearly equal. Other sports, such as diving, badminton, and volleyball, have also seen a few gold medalists leave the system for alternative career paths.</p>

        </div>

        <ImageScroll
          src1='/images/AP8408040148.jpeg'
          caption1='August 4, 1984, Chinese gymnast Li Ning (left) and American gymnast Peter Vidmar receive applause after winning the gold medal in the pommel horse competition at the Los Angeles Olympics. (AP / Suzanne Vlamis)'
          src2='/images/AP10090209277.jpg'
          caption2='September 2, 2010, Li Ning, Chairman of Li-Ning Company Limited, a Chinese sporting goods brand, at a press conference in Hong Kong. (AP / Kin Cheung)'/>

      </div>
      </>
    );
  };

export default CareerTrend;